import { ref, watch } from "vue"

export default function useValidatesNodeProps(input, rules) {
  const internalValue = ref(input.value)
  const isValid = ref(true)
  const error = ref(null)

  watch(internalValue, (newVal) => {
    for(const rule of rules) {
      if (rule.validator(newVal) === false) {
        isValid.value = false
        error.value = rule.message
        return
      }
    }
    input.value = newVal
    isValid.value = true
    error.value = null
  })

  return {
    internalValue,
    isValid,
    error
  }
}
